"use client";

import React, { ReactNode, useState } from "react";
import { ProjectContext, ProjectContextType } from "../context/ProjectContext";

interface ProjectProviderProps {
    children: ReactNode;
}

export const ProjectProvider = ({ children }: ProjectProviderProps) => {
    const [project, setProject] = useState<ProjectContextType["project"]>(null);

    const contextValue: ProjectContextType = {
        project,
        setProject,
    };

    return <ProjectContext.Provider value={contextValue}>{children}</ProjectContext.Provider>;
};
